import { EdgeCreateChannelRepository } from '@/modules/connect/infra'
import type { CreateChannel } from '@/modules/connect/use-cases'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'

export function makeCreateChannel(): CreateChannel {
  return new EdgeCreateChannelRepository(makeSupabaseEdgeHttpClient()).execute
}
